const pillTabSections = document.querySelectorAll("section.pill-tabs");

pillTabSections.forEach((block, i) => {
  const tabWrappers = block.querySelectorAll(".pill-tab-wrapper");
  const tabButtons = block.querySelectorAll("[data-tab-button]");
  const tabContentsDesktop = block.querySelectorAll("[data-tab-content]");
  const tabContentsMobile = block.querySelectorAll("[data-mobile-content]");
  const descTrig = block.querySelectorAll(".desc-trigger");
  const capTrig = block.querySelectorAll(".cap-trigger");
  const columnDesc = block.querySelectorAll(".column-desc");
  const columnCap = block.querySelectorAll(".column-cap");

  // Mobile accordion state management
  let isMobileMode = window.innerWidth < 1024;
  let activeMobileTab = 0;

  // Enhanced mobile accordion functions
  function closeAllMobileAccordions() {
    tabWrappers.forEach((wrapper) => {
      wrapper.classList.remove("mobile-active");
      const content = wrapper.querySelector("[data-mobile-content]");
      if (content) {
        content.style.height = "0px";
        content.style.overflow = "hidden";
        content.style.transition = "height 0.3s ease-in-out";
      }
    });
  }

  function openMobileAccordion(index) {
    const targetWrapper = block
      .querySelector(`[data-tab-button="${index}"]`)
      .closest(".pill-tab-wrapper");
    const targetContent = targetWrapper.querySelector("[data-mobile-content]");

    if (targetContent && !targetWrapper.classList.contains("mobile-active")) {
      targetWrapper.classList.add("mobile-active");

      // Set height to auto temporarily to get natural height
      targetContent.style.height = "auto";
      targetContent.style.overflow = "hidden";
      targetContent.style.transition = "height 0.3s ease-in-out";

      const naturalHeight = targetContent.scrollHeight;
      targetContent.style.height = "0px";

      // Trigger reflow
      targetContent.offsetHeight;

      // Animate to natural height
      targetContent.style.height = naturalHeight + "px";

      // Clean up after animation
      setTimeout(() => {
        if (targetContent.style.height === naturalHeight + "px") {
          targetContent.style.height = "auto";
        }
      }, 300);
    }
  }

  function toggleMobileAccordion(index) {
    const targetWrapper = block
      .querySelector(`[data-tab-button="${index}"]`)
      .closest(".pill-tab-wrapper");
    const isCurrentlyActive = targetWrapper.classList.contains("mobile-active");

    if (isCurrentlyActive) {
      // Close the current accordion
      closeAllMobileAccordions();
      activeMobileTab = null;
    } else {
      // Close all others and open this one
      closeAllMobileAccordions();
      openMobileAccordion(index);
      activeMobileTab = index;
    }
  }

  function switchToTab(index) {
    if (isMobileMode) {
      // Mobile accordion behavior
      toggleMobileAccordion(index);
    } else {
      // Desktop tab behavior
      tabContentsDesktop.forEach((content) => (content.style.display = "none"));
      tabButtons.forEach((button) => {
        button.classList.add("bg-teal", "text-white");
        button.classList.remove("bg-navy", "text-teal");
      });

      // Activate desktop content
      const desktopContent = block.querySelector(
        `[data-tab-content="${index}"]`
      );
      if (desktopContent) {
        desktopContent.style.display = "grid"; // For desktop layout
      }

      // Activate desktop button styles
      const activeButton = block.querySelector(`[data-tab-button="${index}"]`);
      if (activeButton) {
        activeButton.classList.remove("bg-teal", "text-white");
        activeButton.classList.add("bg-navy", "text-teal");
      }
    }
  }
  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const index = button.getAttribute("data-tab-button");
      switchToTab(index);
    });
  });
  function bindColumnSwitcher() {
    capTrig.forEach((btn) => {
      btn.addEventListener("click", () => {
        capTrig.forEach((b) => b.classList.add("active"));
        descTrig.forEach((b) => b.classList.remove("active"));
        columnDesc.forEach((el) => (el.style.display = "none"));
        columnCap.forEach((el) => (el.style.display = "block"));
      });
    });
    descTrig.forEach((btn) => {
      btn.addEventListener("click", () => {
        capTrig.forEach((b) => b.classList.remove("active"));
        descTrig.forEach((b) => b.classList.add("active"));

        columnCap.forEach((el) => (el.style.display = "none"));
        columnDesc.forEach((el) => (el.style.display = "block"));
      });
    });
  }

  // Initialize based on screen size
  function initializeTabs() {
    isMobileMode = window.innerWidth < 1024;

    if (isMobileMode) {
      // Mobile initialization
      closeAllMobileAccordions();
      tabContentsDesktop.forEach((content) => (content.style.display = "none"));

      // Style all buttons as inactive for mobile
      tabButtons.forEach((button) => {
        button.classList.add("bg-teal", "text-white");
        button.classList.remove("bg-navy", "text-teal");
      });

      // Open first accordion by default
      openMobileAccordion(0);
      activeMobileTab = 0;
    } else {
      // Desktop initialization
      switchToTab(0);
    }
  }

  // Handle window resize
  function handleResize() {
    const wasMobileMode = isMobileMode;
    isMobileMode = window.innerWidth < 1024;

    // If switching between mobile and desktop modes
    if (wasMobileMode !== isMobileMode) {
      initializeTabs();
    }
  }

  // Initialize on load
  initializeTabs();

  // Add resize listener with debouncing
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(handleResize, 150);
  });

  bindColumnSwitcher();
});
